module.exports = __webpack_public_path__ + "static/media/error.cbc8724a.svg";